import React from 'react'
import { friendElement,Breadcrumb,getMandOOffice } from './myFunctions';
export default function TermListEntry({oym,term,dropBreadcrumb,authenticated,noTerm,noOffice}) {
    // console.log("term",term);
    let termObject=oym.objectRef(term);
    // console.log("termObject",termObject);
    let friendObject=oym.objectRef(termObject.friend);
    // console.log("friendObject",termObject);
    let meetingObject=oym.objectRef(friendObject.monthlyMeeting);
    let meetingName="";
    if (meetingObject!=null){
        meetingName=meetingObject.name;
    }
    let termString="";
    if (termObject.name=="Standard"){
        termString=termObject.yearExpires;
    } else {
        termString=termObject.name;
    }
    // console.log(friendObject);
    let friendMandOOffice = getMandOOffice(oym,friendObject);
    let friend=(<>{friendObject.name}</>);
    if (authenticated){
        friend=(<button onClick={dropFriendViewBreadcrumb}> {friendObject.name} </button>);
    }
    function dropFriendViewBreadcrumb(e){
        dropBreadcrumb(new Breadcrumb(friendObject.lastName,friendElement(oym,friendObject,dropBreadcrumb)));
    }
    let row = (<tr><td>{friend} </td><td>{meetingName}</td></tr>); // no term
    if (noOffice){
        if (noTerm){
            // defalut
        } else {
            row = (<tr><td>{termString}</td> <td>{friend} </td><td>{meetingName}</td></tr>);
        }
    } else {
        let friendMandOOffice = getMandOOffice(oym,friendObject);
        if (noTerm){
            row = (<tr><td>{friend} </td><td>{meetingName}</td><td>{friendMandOOffice}</td></tr>);
        } else {
            row = (<tr><td>{termString}</td> <td>{friend} </td><td>{meetingName}</td><td>{friendMandOOffice}</td></tr>);
        }
    }

    return (
        <>
            {row}
        </>
    )
}
